import { render, staticRenderFns } from "./ChartPicker.vue?vue&type=template&id=8bc634de&scoped=true&"
import script from "./ChartPicker.vue?vue&type=script&lang=ts&"
export * from "./ChartPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc634de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!Z:/Code/itg/simfile-viewer/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
